import { Pie } from "vue-chartjs/legacy";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale)

export default {
  extends: Pie,
  props: ["data", "options"],
  methods: {
    renderChartLayout() {
      this.renderChart(this.data, {
        borderWidth: "10px",
        hoverBackgroundColor: "red",
        hoverBorderWidth: "10px",
      });
    },
  },
  watch: {
    data: function (val) {
      this.renderChartLayout();
    },
    options: function (val) {
      this.renderChartLayout();
    },
  },
  mounted() {
    this.renderChartLayout();
  },
};
